import { storageDB, StorageIndexDBEnum } from '../storage/StorageDB'
import { SocketService } from './SocketService'

type SocketServiceOptions = {
  /** 是否开启日志打印 */
  logger?: boolean
}

class CryptoSocketService extends SocketService {
  constructor(options?: SocketServiceOptions) {
    super()
    this.isPrintLogger = options?.logger ?? false
  }

  /** 获取币币行情的缓存 */
  public async getMarketQuoteWithCache() {
    const marketQuote = await storageDB.get<SocketResponse.TradingPairData[]>(StorageIndexDBEnum.MarketQuote)
    if (marketQuote) {
      return marketQuote
    }
    return []
  }

  /** 设置币币行情的缓存 */
  public async setMarketQuoteWithCache(marketQuote: SocketResponse.TradingPairData[]) {
    await storageDB.set(StorageIndexDBEnum.MarketQuote, marketQuote)
  }

  /** 获取合约行情的缓存 */
  public async getContractQuoteWithCache() {
    const contractQuote = await storageDB.get<SocketResponse.TradingPairData[]>(StorageIndexDBEnum.ContractQuote)
    if (contractQuote) {
      return contractQuote
    }
    return []
  }

  /** 设置合约行情的缓存 */
  public async setContractQuoteWithCache(contractQuote: SocketResponse.TradingPairData[]) {
    await storageDB.set(StorageIndexDBEnum.ContractQuote, contractQuote)
  }
}

class ExchangeSocketService extends CryptoSocketService {
  constructor(options?: SocketServiceOptions) {
    super(options)
  }

  protected logger(message: string, data?: any) {
    console.log(`[SpotMSocketService] ${message}`, data)
  }
}

class DoubleMSocketService extends CryptoSocketService {
  constructor(options?: SocketServiceOptions) {
    super(options)
  }

  protected logger(message: string, data?: any) {
    console.log(`[DoubleMSocketService] ${message}`, data)
  }
}

export const exchangeSocketService = new ExchangeSocketService()

export const doubleMSocketService = new DoubleMSocketService({
  logger: false,
})
